/**
 * Event-instrumentation constants for the assessment data layer.
 * See docs/features/assessment-data-layer.md.
 *
 * Kept in a separate file from playback.js so the data layer can evolve
 * without touching playback constants — this also keeps our diff out of
 * the parallel accessibility work's surface area.
 */

// How much playback time elapses between chunk_progress heartbeats.
// Driven off audio.timeupdate ticks, NOT setInterval — Chrome throttles
// setTimeout/setInterval to 1 minute in hidden tabs, which would silently
// turn 30s heartbeats into 60s heartbeats. timeupdate naturally pauses
// when audio stops, so throttling produces fewer heartbeats, not wrong totals.
export const HEARTBEAT_INTERVAL_MS = 30000;

// How long a paused session stays "alive" before we emit session_end.
export const PAUSE_TIMEOUT_MS = 5 * 60 * 1000;

// How long the tab can be hidden before we end the session.
export const VISIBILITY_HIDDEN_TIMEOUT_MS = 60 * 1000;

// Buffer size cap. Older non-essential events are dropped when full.
// session_start / session_end / book_complete are preserved.
export const BUFFER_MAX_EVENTS = 200;

// Max events per outbound batch. Server validates per-batch; smaller batches
// improve flush success rate on flaky wifi.
export const FLUSH_BATCH_SIZE = 100;

// Pagehide/keepalive flush chunk size. Stays under the 64KB total-payload
// limit on keepalive fetches even with verbose JSON payloads.
export const KEEPALIVE_CHUNK_SIZE = 50;

// Default flush cadence when buffer is non-empty.
export const FLUSH_INTERVAL_MS = 30000;

// Backoff schedule for flush retries (capped). Resets on success.
export const BACKOFF_INITIAL_MS = 1000;
export const BACKOFF_MAX_MS = 30000;

// localStorage key for buffer persistence across reloads.
export const BUFFER_STORAGE_KEY = 'readwell:event_buffer';
